import { useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useTranslationApp } from "../../../../../lib/i18next";
import { VIEW_RECOMMENDED_QUESTIONS } from "../../../../../i18n/keysTranslations";
import ClickableText from "../../../../Texts/ClickableText";
import ModalInstantFormRecommendedQuestions from "./ModalInstantFormRecommendedQuestions";

const InstantFormRecommendedQuestionsTrigger = ({
  platformData,
  isGeneralDisabledFields,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslationApp();

  const recommendations = platformData?.recommendations?.leadForm;

  if (!recommendations?.questions?.length) {
    return null;
  }

  return (
    <>
      <ClickableText
        disabled={isGeneralDisabledFields}
        onClick={() => setIsOpen(true)}
        sx={{
          color: "text.secondary",
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          flexWrap: "wrap",
        }}
      >
        {t(VIEW_RECOMMENDED_QUESTIONS)}
        <AutoAwesomeIcon sx={{ fontSize: 16 }} />
      </ClickableText>
      {isOpen && (
        <ModalInstantFormRecommendedQuestions
          modalOpen={isOpen}
          onCloseModal={() => setIsOpen(false)}
          recommendations={recommendations}
        />
      )}
    </>
  );
};

export default InstantFormRecommendedQuestionsTrigger;
